// Sibling imports
const LinkModalRecord = require('./record')
const {
  DISMISS_LINK_MODAL
} = require('./actions')

function linkModalReducer(state = new LinkModalRecord(), action) {
  switch (action.type) {
    case DISMISS_LINK_MODAL:
      return state.set('isLinkModalDismissed', true)
    default:
      return state
  }
}

module.exports = linkModalReducer
